module.exports = __webpack_public_path__ + "static/media/disabledAddIcon.c20108e3.svg";